import React from "react";
import { Link, useLocation } from "react-router-dom";
import { WebsiteLogo, Arrow, SearchIcon } from "../Images/svgs";

function SecondNavbar() {
  const location = useLocation();

  const navLinks = [
    { title: "كفالات", to: "/kofalat" },
    { title: "زكاة وصدقات", to: "/zaka-calculator" },
    { title: "حملات", to: "/campaigns" },
    { title: "مشاريع", to: "/projects" },
    { title: "من نحن", to: "/about-us" },
  ];

  return (
    <nav className="w-full bg-gray-50 border-b border-indigo-100">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 flex justify-between items-center h-20">
        {/* Logo Section */}
        <Link
          to="/"
          className="flex-shrink-0 transition-transform hover:scale-105"
        >
          <WebsiteLogo />
        </Link>

        {/* Desktop Navigation Links */}
        <div className="hidden lg:flex items-center gap-8 h-full">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="group flex items-center gap-1 h-full px-2 text-lg text-black hover:text-blue-700 transition-colors relative"
            >
              <span>{link.title}</span>
              <div className="w-4 h-4 transition-transform group-hover:rotate-180">
                <Arrow />
              </div>

              {/* Active Indicator Underline */}
              {location.pathname === link.to && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-700 rounded-t-full" />
              )}
            </Link>
          ))}
        </div>

        {/* Search Bar Section */}
        <div className="hidden lg:flex items-center bg-white border border-gray-300 rounded-full px-4 py-2 shadow-sm hover:border-blue-300 transition-all focus-within:ring-2 focus-within:ring-blue-100">
          <div className="flex items-center gap-2 border-l border-gray-200 pl-3">
            <SearchIcon className="text-gray-400" />
            <input
              className="outline-none text-sm w-32 bg-transparent text-right"
              placeholder="بحث..."
            />
          </div>

          <div className="flex items-center gap-2 pr-3 cursor-pointer group">
            <span className="text-sm text-neutral-900 group-hover:text-blue-700 transition-colors">
              الحملات
            </span>
            <div className="w-4 h-4 text-gray-400 group-hover:text-blue-700">
              <Arrow />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default SecondNavbar;
